// 9fbef606107a605d69c0edbcd8029e5d
import styled from 'styled-components';
import Row from '@tcp/core/src/components/common/atoms/Row';
import ProductPrice from '@tcp/core/src/components/features/browse/ProductDetail/molecules/ProductPrice/ProductPrice';

export const StyledPriceContainer = styled(ProductPrice)`
  .actual-price {
    ${(props) => {
      return (
        props.isBundlePageRedesign &&
        ` @media ${props.theme.mediaQuery.smallOnly} {
          margin-top: 0;
          font-size: ${props.theme.fonts.fontSize.body.bodytext.copy4}px;
          padding-top: ${props.theme.spacing.ELEM_SPACING.XXS};
        }
        font-size: ${props.theme.fonts.fontSize.body.bodytext.copy6}px;
        padding-top: ${props.theme.spacing.ELEM_SPACING.XXS};
     `
      );
    }};
  }
`;

export const StyledToggleOptionWrapper = styled(Row)`
  display: flex;
  align-items: center;
  justify-content: flex-end;
  margin-top: ${(props) => props.theme.spacing.ELEM_SPACING.MED};

  .switch {
    margin-left: auto;
  }
`;
